import fetchJson from '../lib/react-admin-loopback/fetch';
import { stringify } from 'query-string';

export async function reqReviews(customerId, dateFrom , dateTo) {
  
  const fromdate = dateFrom.replaceAll('-' ,'') ;
  const todate = dateTo.replaceAll('-' ,'') ;
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    queryParams: JSON.stringify({
      dateFrom : fromdate,
      dateTo : todate
    })
  };
  const url = `${apiUrl}/customers/${customerId}/reviews?${stringify(params)}`;
  
  const { json } = await fetchJson(url);
  return {
    data : json
  };
}